import * as React from 'react';
import { EntityLoader } from '@web-config-app/core-react';
import type {
  ControlProps,
  EntitySelectControlSchema,
} from '@web-config-app/entity-form';
import {
  useEntityDetailsProps,
  useEntityReferenceSchemaType,
  Hidden,
  useEntityFormControl,
} from '@web-config-app/entity-form';
import { isRelationshipEntityReference } from '@web-config-app/schema-utils';
import { ConfigEntityReferenceControlWrapper } from './entity-reference-control-wrapper/config-entity-reference-control-wrapper.component';
import { DomainEntityReferenceControlWrapper } from './entity-reference-control-wrapper/domain-entity-reference-control-wrapper.component';
import { EntityRelationshipControlWrapper } from './entity-relationship-control-wrapper/entity-relationship-control-wrapper.component';
import { getDomainEntityAttributesQueryProps } from './get-domain-entity-attributes-query-props';

export const EntitySelectControl: React.FC<ControlProps> = (props) => {
  const { schema } = props;

  // Check if field should be hidden
  const entityFormControlProps = useEntityFormControl(props);
  const { hidden } = entityFormControlProps;

  const entityType = useEntityReferenceSchemaType({
    // eslint-disable-next-line react/destructuring-assignment
    schema: schema as EntitySelectControlSchema,
  });
  const { isUsingConfigAppBackend, entityRootData } = useEntityDetailsProps();

  const domainEntityAttributesQuery = React.useMemo(
    () =>
      getDomainEntityAttributesQueryProps(
        schema['x-entity-reference'],
        entityRootData,
      ),
    [entityRootData, schema],
  );

  if (hidden) {
    return <Hidden {...entityFormControlProps} />;
  }

  const { 'x-entity-reference': entityReference } =
    schema as EntitySelectControlSchema;

  const EntityReferenceControlWrapper = isUsingConfigAppBackend
    ? ConfigEntityReferenceControlWrapper
    : DomainEntityReferenceControlWrapper;

  const Wrapper = isRelationshipEntityReference(entityReference)
    ? EntityRelationshipControlWrapper
    : EntityReferenceControlWrapper;

  return (
    <EntityLoader
      entityType={entityType}
      render={(entity) => (
        <Wrapper
          {...props}
          referencedEntity={entity}
          domainEntityAttributesQuery={domainEntityAttributesQuery}
        />
      )}
    />
  );
};
